import React, { Fragment, useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  TabPane,
  TabContent,
} from "reactstrap";
import welcomeImage from "./../../../assets/images/welcome_page.svg";
import Penilaian360Component from "./Components/Penilaian360Component"

const DashboardView = () => {
  const userdata = JSON.parse(localStorage.getItem("userdata"));

  return (
    <Fragment>
      <Penilaian360Component/>
      <Container fluid>
        <Row>
          <Col xl={12}>
            <div className="p-4 mb-4 bg-light rounded-3">
              <Row>
                <Col md="8">
                  <img src={welcomeImage} className="img-fluid" />
                </Col>
                <Col md="4">
                  <div className="container-fluid">
                    <h1 className="display-6 fw-bold">Selamat Datang</h1>
                    <h3 className="display-8 fw-bold">
                      {userdata.employee_full_name}
                    </h3>
                    <h5>{userdata.employee_current_position_name}</h5>
                    <hr />
                    <span className="col-md-8 fs-5">
                      Sistem Informasi Kepegawaian <br />
                      Kementerian Investasi dan Hilirisasi / BKPM
                    </span>
                    {/* <button className="btn btn-primary btn-lg" type="button">Example</button> */}
                  </div>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default DashboardView;
